import React, { useRef, useEffect, useState } from 'react'
import { debounce } from 'lodash-es'
import { Container, H2, BookList } from './styles'
import Book from '../Book'

const BooksContainers = ({ books, pickBook, isPanelOpen, title }) => {
    const [scroll, setScroll] = useState(0)
    const prevPanelState = useRef(false)

    useEffect(() => {
        const handleScroll = debounce(() => {
            setScroll(window.scrollY)
        }, 100)
        if (!isPanelOpen) {
            window.addEventListener('scroll', handleScroll)
        }

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [isPanelOpen])

    useEffect(() => {
        if (prevPanelState.current && !isPanelOpen) {
            window.scroll(0, scroll)
        }
        prevPanelState.current = isPanelOpen
    }, [isPanelOpen, prevPanelState])



    return (
        <Container $isPanelOpen={isPanelOpen} $top={scroll}>
            <H2>{title}</H2>
            <BookList>
                {books.map((book) => (
                    <Book key={book.id} book={book} pickBook={pickBook} />
                ))}
            </BookList>
        </Container>
    )
}

export default BooksContainers